import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccessControlController } from '@shared/src/controllers/accesscontrol/accesscontrol.controller';
import { ForkliftRouteDetailDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftRouteDetailDto';
import { AccessControlGatePlateDto } from '@shared/src/dtos/accesscontrol/gate/plate/AccessControlGatePlateDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { RouteCardItemExpandDto } from '@shared/src/dtos/route/RouteCardItemExpandDto';
import { RouteController } from '@shared/src/public-api';

@Component({
    selector: 'shared-forklift-right-route',
    templateUrl: './shared.forklift.right.route.component.html',
    styleUrls: ['./shared.forklift.right.route.component.scss']
})
export class SharedForkliftRightRouteComponent {

    constructor(private accessControlController: AccessControlController, private routeController: RouteController) { }

    @Output() public refresh = new EventEmitter<boolean>();

    public detail: ForkliftRouteDetailDto | null = null;
    public options: OptionsStripDto | null = null;


    private _value: AccessControlGatePlateDto | null = null;;
    @Input()
    public set value(v: AccessControlGatePlateDto) {
        if (v == this._value)
            return;
        this._value = v;
        this.detail = null;
        if (v?.phaseId) {
            this.accessControlController.getForkliftRouteDetail(v.phaseId).subscribe(detail => {
                this.detail = detail;
                this.options = OptionsStripDto.sync(detail.options, this.options);
                this.option = this.options.getActualSelected()?.optionId;
            });
        }
    }
    public get value(): AccessControlGatePlateDto | null {
        return this._value;
    }

    public option: string | null = "";
    public route: RouteCardItemExpandDto | null = null;
    onClickOption(option: OptionDto) {
        this.option = option.optionId;

        if (this.detail != null)
            if ("DRIVERPLATE" == this.option)
                this.routeController.getRouteCardItemExpand(this.detail.routeId).subscribe(d => {
                    this.route = d;
                });
    }

    onRouteRefresh($event: boolean) {
        this.refresh.next($event);
    }
}
